const MAX_LEN = 512;
const BLOCKED_PREFIXES = ['/login', '/auth/'];

/**
 * 校验登录成功后允许的站内跳转路径，防止开放重定向。
 */
export function sanitizePostLoginRedirect(raw: unknown): string {
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s || s.length > MAX_LEN) return '';
  if (!s.startsWith('/') || s.startsWith('//') || s.includes('://')) return '';
  for (const p of BLOCKED_PREFIXES) {
    if (s === p || s.startsWith(`${p}?`) || s.startsWith(`${p}/`)) return '';
  }
  if (s.startsWith('/account-merge?')) {
    try {
      const url = new URL(s, window.location.origin);
      const token = url.searchParams.get('token')?.trim();
      if (token && /^[a-fA-F0-9]{32}$/.test(token)) {
        return `/account-merge?token=${token.toLowerCase()}`;
      }
      return '';
    } catch {
      return '';
    }
  }
  return s;
}

export function resolveLoginSuccessRedirect(
  redirectFromQuery: unknown,
  userInfo?: { postLoginRedirect?: string | null } | null,
): string {
  const fromUser = sanitizePostLoginRedirect(userInfo?.postLoginRedirect);
  if (fromUser) return fromUser;
  const fromQuery = sanitizePostLoginRedirect(redirectFromQuery);
  if (fromQuery) return fromQuery;
  return '/dashboard';
}
